module.exports = __webpack_public_path__ + "media/images/perceive-agent-quantity-count-347c3340381b8968c8ae417d9399a392.png";